import React from 'react'
import {FaCreativeCommonsZero} from 'react-icons/fa'

function Empty({objectName}) {
    return (
        <div className='alert rounded-2xl border-primary/75 border-2 mt-3 px-4 justify-center'>
            <FaCreativeCommonsZero className='h-7 w-7 text-secondary'/>
            <p>No {objectName} found yet!</p>
        </div>
    )
}

export default Empty